import React from 'react';

export default function HowItWorks({ language }) {
  const titles = {
    es: "Cómo funciona",
    en: "How it Works",
    pt: "Como funciona"
  };

  return (
    <section id="how" className="bg-[#48887B] py-12">
      <h2 className="text-white text-3xl md:text-5xl font-bold text-center">
        {titles[language]}
      </h2>
    </section>
  );
}